import React, { useRef } from 'react'
import { useToggle, useOnClickOutside } from 'hooks'
import { Pill, ScrollableDirective } from 'components/Zui'
import { IconClose } from 'components/Zui/Icon'

const FilterPills = ({ data, removeFilter }) => {
    return (
        <div className="filter-pills-wrapper">
            {data?.map(d => {
                return typeof d.value === 'string' ? (
                    <Pill
                        closable
                        key={d.label}
                        onClose={() => removeFilter({ key: d.name, value: d.val })}
                    >
                        {d.label}&nbsp;<b>{d.value}</b>
                    </Pill>
                ) : (
                    <MultiFilterPills key={d.label} data={d} removeFilter={removeFilter} />
                )
            })}
        </div>
    )
}

const MultiFilterPills = ({ data, removeFilter }) => {
    const { isOpen, onClose, onToggle } = useToggle()
    const myRef = useRef(null)
    useOnClickOutside(myRef, onClose, 'filterPills')

    return data.value.length < 2 ? (
        <>
            {data.value.length > 0 && (
                <Pill
                    closable
                    key={data.label}
                    onClose={() => removeFilter({ key: data.name, value: data.value[0].val })}
                >
                    {data.label} &nbsp;<b>{data.value[0].key}</b>
                </Pill>
            )}
        </>
    ) : (
        <Pill key={data.label}>
            <div className="multi-pill-wrapper">
                <div className="multi-option-pill">
                    <span>
                        {data.label}&nbsp;<b>{data.value.length}</b>
                    </span>
                    <div className="pill-open-icon">
                        <zui-icon-arrows-arrow-outline-actually-centred-down
                            size="s12"
                            onClick={onToggle}
                            data-ref="filterPills"
                        />
                    </div>
                </div>
                {isOpen && (
                    <div className="pill-options-wrapper" ref={myRef}>
                        <ScrollableDirective style={{ maxHeight: '320px' }}>
                            {data.value.map(v => (
                                <div className="pill-item-wrapper" key={v.key}>
                                    <span>{v.key}</span>
                                    <span>
                                        <IconClose
                                            size="s"
                                            onClick={() =>
                                                removeFilter({ key: data.name, value: v.val })
                                            }
                                        />
                                    </span>
                                </div>
                            ))}
                        </ScrollableDirective>
                    </div>
                )}
            </div>
        </Pill>
    )
}

export default React.memo(FilterPills)
